define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/scraperItemView.tmpl");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var Dropdown = require("ui/dropdown/Dropdown");
    var InputField = require("ui/input-field/InputField");
    var ValidationUtilities = require("utils/ValidationUtilities");
    var Button = require("ui/button/Button");

    var ScraperItemView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        ScraperItemView = Marionette.ItemView.extend({

            template:template,
            tagName:'li',
            className:'scraper-item',

            ui: {
                "mapByDropdownContainer": ".map-by-container",
                "mapByPropertyValue": ".map-by-value",
                "mapByReset": ".map-by-reset-container"
            },

            uiComponents: {
                mapByDropdown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.mapByDropdownContainer",
                        name : "mapByDropdown",
                        permutation : Dropdown.PERMUTATION.SMALL,
                        selectedOption: "view.getSelectedMapByItem",
                        items : "view.getMapByList",
                        testCollision: true,
                        collisionWithinSelector: ".le .data-sources-edit-container"
                    },
                    events: {
                        "change": "onMapByDropdownChange"
                    }
                },
                propertyValue: {
                    type: InputField, // Component type to be instantiated
                    options: {         // Component initialization options
                        permutation: InputField.Permutation.P,
                        el: "view.ui.mapByPropertyValue",
                        value: "view.getPropertyValue"
                    },
                    events: {                                        // Events that should be dispatched and propagated from the component to the parent view
                        onblur: "onMapByPropertyValueBlur",
                        change: "onMapByPropertyValueChange"
                    }
                },
                resetButton : {
                    type : Button,
                    options : {
                        permutation:Button.PERMUTATION.BLUELINK,
                        el : "view.ui.mapByReset",
                        initState : Button.STATES.ENABLED
                    },
                    events : {
                        click : "resetMapByValues"
                    }
                }
            },
            validationSettings : {
                propertyValue : {
                    uiKey:"propertyValue",
                    errKeys:["mapByValue"],
                    uiType:"uiComponents"
                },
                mapByDropdown : {
                    uiKey:"mapByDropdown",
                    errKeys:["mapById"],
                    uiType:"uiComponents"
                }

            },

            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize : function (options) {
                LEManager.logger.debug("ScraperItemView:initialize");
                this.vent = LEManager.media.channel("dataSources").vent;
            },

            customTemplateHelpers: function() {
                var that = this;
                return {
                    propertyName: function(){
                        return that.model.getName();
                    },
                    propertyLogicalName: function() {
                        return that.model.getLogicalName();
                    }
                };
            },

            onRender: function(){
                LEManager.logger.debug("ScraperItemView:onRender");
                this.uiComponents.mapByDropdown.setSelection(this.getSelectedMapByItem());
                this.setPropertyValuePlaceholder();
            },

            onInvalid:function (model, errors) {
                LEManager.logger.info("ScraperItemView:onInvalid");
                ValidationUtilities.setValidationErrors(this);
            },

            clearErrors: function(){
                LEManager.logger.debug("ScraperItemView:clearErrors");
                this.uiComponents.mapByDropdown.setError(false);
                this.uiComponents.propertyValue.setError(false);
            },

            getMapByDropdownPlaceholder: function(){
                LEManager.logger.debug("ScraperItemView:getMapByDropdownPlaceholder");
                var selectedId = this.getSelectedMapByItem();
                if(selectedId === -1){
                    return LE.translator.translate('LEManager.manager.dataSources.map.dropdown.caption');
                }
                else{
                    var currentElementKey = ManagerConfig.dataSources.mapping.mapToLogical[selectedId.toString()];
                    return LE.translator.translate('LEManager.manager.dataSources.map.' + currentElementKey + ".placeholder");
                }
            },

            getPropertyValue: function(){
                LEManager.logger.debug("ScraperItemView:getPropertyValue");
                return this.model.getMapByValue();
            },

            getSelectedMapByItem: function(){
                LEManager.logger.debug("ScraperItemView:getSelectedMapByItem");
                return this.model.getMapById();
            },

            resetMapByValues: function(){
                LEManager.logger.debug("ScraperItemView:resetMapByValues");
                this.uiComponents.mapByDropdown.setSelection(-1);
                this.uiComponents.propertyValue.setValue("");
                this.uiComponents.propertyValue.setError(false);
                this.model.setMapById(-1);
                this.model.setMapByValue("");
                this.setPropertyValuePlaceholder();
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.PROPERTIES_CHANGED, this.model);
            },

            getMapByList: function(){
                LEManager.logger.debug("ScraperItemView:getMapByList");
                var mapByArr = ManagerConfig.dataSources.mainConfig.scraper.MAP_BY_VALUES;
                var items = [{key: -1, value: LE.translator.translate('LEManager.manager.dataSources.map.dropdown.caption')}];
                items = _.union(items, _.map(mapByArr, function(num) {
                    var currentElementKey = ManagerConfig.dataSources.mapping.mapToLogical[num.toString()];
                    return {
                        key:   num,
                        value: LE.translator.translate('LEManager.manager.dataSources.map.' + currentElementKey + ".name"),
                        tooltipTitle: LE.translator.translate('LEManager.manager.dataSources.map.' + currentElementKey + ".tooltip"),
                        tooltipPosition: Dropdown.TOOLTIP_POSITION.RIGHT
                    };
                }));
                return new Dropdown.Collection(items);
            },

            onMapByDropdownChange: function(componentId, eventName, value){
                LEManager.logger.debug("ScraperItemView:onMapByDropdownChange");
                if (_.isObject(value) && _.has(value, "selectedKey")){
                    LEManager.logger.debug("ScraperItemView:onMapByDropdownChange - selectedKey: " + value.selectedKey);
                    this.setMapById(value.selectedKey);
                    this.vent.trigger(ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.PROPERTIES_CHANGED, this.model);
                }

                this.setPropertyValuePlaceholder();
            },

            setPropertyValuePlaceholder: function(){
                LEManager.logger.debug("ScraperItemView:setPropertyValuePlaceholder");
                this.uiComponents.propertyValue.setPlaceholder(this.getMapByDropdownPlaceholder());
                this.uiComponents.propertyValue.setEnabled(this.model.getMapById() !== -1);
            },

            setMapById: function(mapById){
                LEManager.logger.debug("ScraperItemView:setMapById - mapById: " + mapById);
                if (this.model.getMapById() !== mapById){
                    this.model.setMapById(mapById);
                }
            },

            onMapByPropertyValueBlur: function(componentId, eventName, value){
                LEManager.logger.debug("ScraperItemView:onMapByPropertyValueBlur");
                this.setMapByValue(value);
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.PROPERTIES_CHANGED, this.model);
            },

            setMapByValue: function(value){
                LEManager.logger.debug("ScraperItemView:setMapByValue - value: " + value);
                if (this.model.getMapByValue() !== value){
                    //var val = value === "" ? undefined : value;
                    this.model.setMapByValue(value);
                }
            },

            onMapByPropertyValueChange: function(componentId, eventName, value){
                LEManager.logger.debug("ScraperItemView:onMapByPropertyValueChange");
                //this.vent.trigger(ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.PROPERTIES_CHANGED, this);
                var val = value === "" ? undefined : value;
                this.setMapByValue(val);
            },

            onClose: function() {
                LEManager.logger.debug("ScraperItemView:onClose");
            }

        });
    });

    return ScraperItemView;
});
